import { createContext, useContext } from 'react';

export const ResourceAssignmentDialogContext = createContext();

export default ResourceAssignmentDialogContext;

export const useResourceAssignmentDialogContext = () =>
  useContext(ResourceAssignmentDialogContext);
